<div class="flex h-7 items-center justify-between mb-5">
  <div class="text-[1.125rem] leading-7 font-bold text-font-primary">Edit Transaction Limits ({{ currency }})</div>
</div>

<div class="text-font-primary flex flex-col gap-5">
  @for (item of transactionLimits; track item.id) {
    <div>
      <div class="flex gap-7 text-[0.8125rem] leading-[1.125rem] mb-1">
        <div class="text-font-secondary w-32">Current {{ item.label }} Limit</div>
        <div>New {{ item.label }} Limit</div>
      </div>

      <div class="flex items-center gap-7">
        <div class="text-[0.9375rem] font-semibold w-32">
          {{ item.currency | currencySign }}
          {{ (item.amount | number: '1.2-2') || '' | mask: 'separator' : { thousandSeparator: ',' } }}
        </div>

        <div class="flex-1">
          <div class="rkt-form">
            <app-limit-edit-item-field
              [maxAmountValue]="maxLimits[item.limitType]"
              [limitType]="item.limitType"
              [initialValue]="values[item.limitType]"
              [currencySign]="item.currency | currencySign"
              (changed)="setLimitAmountValue($event, item.limitType)"
              (errored)="onLimitAmountValueError($event, item.limitType)"
            ></app-limit-edit-item-field>
          </div>
        </div>
      </div>
    </div>
  }
</div>

@if (submitError()) {
  <div class="details-page-edit-form-error mt-5">{{ submitError() }}</div>
}

<div class="buttons">
  <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
  <button rktButton type="submit" (click)="onSave()" [disabled]="isLimitsHasError || !isLimitsModified || isLoading">Save</button>
</div>
